import NextLink from 'next/link';
import {useIntl} from 'react-intl';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
  Text,
  Button,
  ModalProps,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {CoinsIcon} from '@eksab/assets/icons';

import {usePaymentInitiator} from '@eksab/features/payment/hooks';

interface BuyCoinsModalProps extends Omit<ModalProps, 'children'> {
  fees: number;
}

export const BuyCoinsModal = ({fees, ...props}: BuyCoinsModalProps) => {
  const format = useIntl().formatNumber;

  const t = useTranslate();
  const setPaymentInitiatorURL = usePaymentInitiator((state) => state.setURL);

  return (
    <Modal motionPreset="slideInBottom" variant="full" size="sm" {...props}>
      <ModalOverlay />

      <ModalContent px="6" textAlign={['start', 'center']} rounded="xl" shadow="sm" overflow="hidden">
        <ModalHeader display="flex" flexDir="column" gap="3" mt={[7, 20]} px={[0, 2]} py="1">
          <Heading textTransform="capitalize" fontSize={['md', 'xl']} fontWeight="800">
            {t('competition.modal.buy.heading')}
          </Heading>

          <Text fontSize={['sm', 'md']} fontWeight="500" data-testid="buy-coins-to-join">
            {t('competition.modal.buy.subheading')}
          </Text>
        </ModalHeader>
        <ModalCloseButton top="4" size="lg" />

        <ModalBody
          display="flex"
          flexDir={['row', 'column']}
          alignItems="center"
          gap={[3, 1]}
          mt={[2, 3]}
          mb={[4, 7]}
          px="0"
        >
          <Text textTransform="capitalize" fontSize="sm" fontWeight="800">
            {t('competition.modal.fees')}
          </Text>

          <Box display="flex" gap="3" alignItems="center" fontSize="xl" fontWeight="500">
            <CoinsIcon width="7" height="8" />
            {format(fees)}
          </Box>
        </ModalBody>

        <ModalFooter pt="0" px="0" pb="9">
          <Button
            as={NextLink}
            onClick={() => setPaymentInitiatorURL(window.location.pathname + window.location.search)}
            href="/store/coins/packages"
            w="full"
            tabIndex={1}
          >
            {t('competition.modal.buy.cta')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
